import React from 'react';
import { FaCircleInfo } from 'react-icons/fa6';

export const ClientNoConsent = () => {
  return (
    <div className="au-card" style={{ animation: "auFadeIn 0.3s ease-out both", border: "1px solid #fecaca" }}>
      <div className="au-card-body" style={{ padding: "24px", background: "rgba(220,38,38,0.03)", display: "flex", gap: "12px", alignItems: "flex-start" }}>
        <FaCircleInfo style={{ color: "#dc2626", fontSize: "1.2rem", marginTop: "2px" }} />
        <div>
          <h5 style={{ color: "#b91c1c", fontSize: "0.95rem", fontWeight: 600, margin: "0 0 4px 0" }}>Inspection Blocked</h5>
          <p style={{ color: "#dc2626", fontSize: "0.85rem", margin: 0 }}>
            You are not authorised to create an inspection report without explicit client consent. Please contact your supervisor.
          </p>
        </div>
      </div>
    </div>
  );
};
